import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/standard/ask-ico.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-391e69f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"width":"100%","overflow-x":"hidden"} }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "banner" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "textbox" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "banner-text1" }, "常见问题"),
    /*#__PURE__*/_createElementVNode("div", { class: "banner-text2" }, "助力建设全国统一大市场，优化市场营商环境")
  ])
], -1))
const _hoisted_3 = { class: "box6" }
const _hoisted_4 = { style: {"display":"flex"} }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "",
    class: "askico"
  })
], -1))
const _hoisted_6 = { class: "asktitle" }
const _hoisted_7 = { class: "asktext" }
const _hoisted_8 = { class: "pagination" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "远程异地评标和评标专家库共享专栏", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "btn" }, "联系我们", -1))
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bottombox2" }, null, -1))

import { reactive, toRefs, ref, onMounted } from 'vue'

import {  getproblemList, } from '../utils/axios/index.js'
import { ro } from 'element-plus/es/locale/index.js';
import { useRoute } from 'vue-router'
import { useRouter } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  __name: 'problem',
  setup(__props) {

const route = useRoute()
const router = useRouter();
//查询参数
let Listparms = ref({
    current: 1,
    size: 100,
    // problemType: '',
})
//跳转联系我们
const tous = () => {
    router.push('/contactUs')
}

onMounted(() => {

    //获取问题列表
    MgetproblemList()






})


let problemList = ref([])

//获取问题列表

const MgetproblemList = () => {
    getproblemList(Listparms.value).then(res => {
        problemList.value = res.data.records
    }).catch(res => {

    })
}

//分页size改变
const handleSizeChange = (val) => {
    Listparms.value.size = val
    getproblemList(Listparms.value).then(res => {
        problemList.value = res.data.records
        Listparms.value.total = res.data.total
    }).catch(err => {
    })
}
//分页页数改变

const handleCurrentChange = (val) => {
    Listparms.value.current = val
    getproblemList(Listparms.value).then(res => {
        problemList.value = res.data.records
        Listparms.value.total = res.data.total
    }).catch(err => {
    })
}







let newParms = ref({
    current: 1,
    size: 50,
    total: 0,
})






return (_ctx: any,_cache: any) => {
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_collapse, {
          modelValue: _ctx.activeNames,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeNames) = $event)),
          onChange: _ctx.handleChange,
          class: "problembox",
          accordion: ""
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(problemList), (item) => {
              return (_openBlock(), _createBlock(_component_el_collapse_item, {
                title: item.questionTitle,
                name: item.questionSN,
                size: "big"
              }, {
                title: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _hoisted_5,
                    _createTextVNode(),
                    _createElementVNode("span", _hoisted_6, _toDisplayString(item.questionTitle), 1)
                  ])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, _toDisplayString(item.answers[0].answerContent), 1)
                ]),
                _: 2
              }, 1032, ["title", "name"]))
            }), 256))
          ]),
          _: 1
        }, 8, ["modelValue", "onChange"]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_el_pagination, {
            "current-page": _unref(newParms).current,
            "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => ((_unref(newParms).current) = $event)),
            "page-size": _unref(newParms).size,
            "onUpdate:pageSize": _cache[2] || (_cache[2] = ($event: any) => ((_unref(newParms).size) = $event)),
            "page-sizes": [50, 100, 150, 200],
            layout: "prev, pager, next,sizes,",
            total: _unref(newParms).total,
            background: "",
            onSizeChange: handleSizeChange,
            onCurrentChange: handleCurrentChange
          }, null, 8, ["current-page", "page-size", "total"])
        ])
      ]),
      _createElementVNode("div", {
        class: "bottom",
        onClick: tous
      }, _hoisted_11),
      _hoisted_12
    ])
  ]))
}
}

})